import { createSlice } from '@reduxjs/toolkit';
import { dispatch } from '../../store';
import { get, post, put } from '../../../inteceptor';
import moment from 'moment';

const initialState = {
  error: null,
  time: null,
  data: [],
  addData: {},
  sorted: [],
};

const slice = createSlice({
  name: 'assetCategories',
  initialState,
  reducers: {
    hasError(state, action) {
      state.error = { message: action.payload, time: moment.now().toString() };
    },

    getAssetCategoriesSuccess(state, action) {
      state.data = action.payload.data;
    },

    addOrUpdateAssetCategories(state, action) {
      state.addData = {
        data: action.payload.data,
        time: moment.now().toString(),
      };
    },

    clearAll(state) {
      state.addData = {};
      state.error = {};
    },

    onBackStep(state) {
      state.checkout.activeStep -= 1;
    },

    onNextStep(state) {
      state.checkout.activeStep += 1;
    },

    onGotoStep(state, action) {
      const goToStep = action.payload;
      state.checkout.activeStep = goToStep;
    },
  },
});

export default slice.reducer;

export const { filterCategories } = slice.actions;

export function getAssetCategories() {
  return async () => {
    try {
      const response = await get(`AssetCategories`);
      if (response.status) {
        dispatch(slice.actions.getAssetCategoriesSuccess(response));
      } else {
        dispatch(slice.actions.hasError(response.message));
      }
    } catch (error) {
      console.log(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function addAssetCategories(body) {
  return async () => {
    try {
      const response = await post(`AssetCategories`, body);
      if (response.status) {
        dispatch(slice.actions.addOrUpdateAssetCategories(response));
      } else {
        dispatch(slice.actions.hasError(response.message));
      }
    } catch (error) {
      console.log(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function updateAssetCategories(body) {
  return async () => {
    try {
      const response = await put(`AssetCategories`, body);
      if (response.status) {
        dispatch(slice.actions.addOrUpdateAssetCategories(response));
      } else {
        dispatch(slice.actions.hasError(response.message));
      }
    } catch (error) {
      console.log(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}
